import { createStore } from 'vuex';

import accounts from './modules/accounts';
import agentBots from './modules/agentBots';
import agents from './modules/agents';
import assignmentPolicies from './modules/assignmentPolicies';
import attributes from './modules/attributes';
import auditlogs from './modules/auditlogs';
import auth from './modules/auth';
import automations from './modules/automations';
import bulkActions from './modules/bulkActions';
import campaigns from './modules/campaigns';
import customMessageTemplates from './modules/customMessageTemplates';
import cannedResponse from './modules/cannedResponse';
import contactConversations from './modules/contactConversations';
import contactLabels from './modules/contactLabels';
import contactNotes from './modules/contactNotes';
import contacts from './modules/contacts';
import conversationLabels from './modules/conversationLabels';
import conversationMetadata from './modules/conversationMetadata';
import conversationPage from './modules/conversationPage';
import conversations from './modules/conversations';
import conversationSearch from './modules/conversationSearch';
import conversationStats from './modules/conversationStats';
import conversationTypingStatus from './modules/conversationTypingStatus';
import conversationUnreadCounts from './modules/conversationUnreadCounts';
import conversationWatchers from './modules/conversationWatchers';
import csat from './modules/csat';
import customRole from './modules/customRole';
import customViews from './modules/customViews';
import dashboardApps from './modules/dashboardApps';
import draftMessages from './modules/draftMessages';
import globalConfig from 'shared/store/globalConfig';
import inboxAssignableAgents from './modules/inboxAssignableAgents';
import inboxes from './modules/inboxes';
import inboxMembers from './modules/inboxMembers';
import integrations from './modules/integrations';
import labels from './modules/labels';
import macros from './modules/macros';
import notifications from './modules/notifications';
import reports from './modules/reports';
import sla from './modules/sla';
import slaReports from './modules/SLAReports';
import sidebarSortPreferences from './modules/sidebarSortPreferences';
import summaryReports from './modules/summaryReports';
import teamMembers from './modules/teamMembers';
import teams from './modules/teams';
import userNotificationSettings from './modules/userNotificationSettings';
import webhooks from './modules/webhooks';
import lumeraiAssistants from './lumerai/assistant';
import lumeraiDocuments from './lumerai/document';
import lumeraiResponses from './lumerai/response';
import lumeraiInboxes from './lumerai/inboxes';
import lumeraiBulkActions from './lumerai/bulkActions';
import copilotThreads from './lumerai/copilotThreads';
import copilotMessages from './lumerai/copilotMessages';
import lumeraiScenarios from './lumerai/scenarios';
import lumeraiTools from './lumerai/tools';
import lumeraiCustomTools from './lumerai/customTools';
import tickets from './modules/tickets';

const plugins = [];

export default createStore({
  modules: {
    accounts,
    agentBots,
    agents,
    assignmentPolicies,
    attributes,
    auditlogs,
    auth,
    automations,
    bulkActions,
    campaigns,
    customMessageTemplates,
    cannedResponse,
    contactConversations,
    contactLabels,
    contactNotes,
    contacts,
    conversationLabels,
    conversationMetadata,
    conversationPage,
    conversations,
    conversationSearch,
    conversationStats,
    conversationTypingStatus,
    conversationUnreadCounts,
    conversationWatchers,
    csat,
    customRole,
    customViews,
    dashboardApps,
    draftMessages,
    globalConfig,
    inboxAssignableAgents,
    inboxes,
    inboxMembers,
    integrations,
    labels,
    macros,
    notifications,
    reports,
    sla,
    slaReports,
    sidebarSortPreferences,
    summaryReports,
    teamMembers,
    teams,
    userNotificationSettings,
    webhooks,
    lumeraiAssistants,
    lumeraiDocuments,
    lumeraiResponses,
    lumeraiInboxes,
    lumeraiBulkActions,
    copilotThreads,
    copilotMessages,
    lumeraiScenarios,
    lumeraiTools,
    lumeraiCustomTools,
    tickets,
  },
  plugins,
});
